import { render, staticRenderFns } from "./auth-container.vue?vue&type=template&id=42c79abd"
import script from "./auth-container.vue?vue&type=script&lang=ts"
export * from "./auth-container.vue?vue&type=script&lang=ts"
import style0 from "./auth-container.vue?vue&type=style&index=0&id=42c79abd&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c79abd')) {
      api.createRecord('42c79abd', component.options)
    } else {
      api.reload('42c79abd', component.options)
    }
    module.hot.accept("./auth-container.vue?vue&type=template&id=42c79abd", function () {
      api.rerender('42c79abd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-auth-container/auth-container.vue"
export default component.exports